import * as actions from './slice'
import { stackAlert } from '../toast/helpers'

export const getHomepage = {
  eventName: 'pagesGet',
  onStart: {
    action: actions.setLoading,
    redux: true
  },
  onSuccess: {
    action: actions.setPage,
    redux: true
  },
  onError: [
    { action: actions.setError, redux: true },
    { action: stackAlert('Unable to load homepage', 'error'), redux: true }
  ]
}
